import { createFileRoute } from "@tanstack/react-router"
import { SettingsPage } from "~/components/design-system/pages"
import { InviteUserDialog } from "~/components/settings/dialogs/InviteUserDialog"
import { InvitationsCard } from "~/components/settings/InvitationsCard"
import { UserManagementCard } from "~/components/settings/UserManagementCard"

export const Route = createFileRoute("/_auth/settings/_layout/users")({
  component: UsersSettingsPage,
})

function UsersSettingsPage() {
  return (
    <SettingsPage title="Users" width="md" actions={<InviteUserDialog />}>
      <UserManagementCard />
      <InvitationsCard showInviteAction={false} />
    </SettingsPage>
  )
}
